<!-- 注册审批-详情 -->
<template>
  <div id="detail_accountManage" class="fromPage">
    <!-- 页面标题 -->
    <div class="title_page">用户注册信息</div>
    <!-- 基础信息 -->
    <div class="form_detail">
      <div v-for="(item,i) in keyItems" :key="i">
        <div>{{item.title}}</div>
        <div v-if="item.type=='status'" class="nowrap" :class="item.class_status?item.class_status[accountItem[item.key]]:''">
          {{item.text_status[accountItem[item.key]]?item.text_status[accountItem[item.key]]:'--'}}</div>
        <div v-else-if="item.type=='money'" class="nowrap">{{ `￥${common.formatNumber(accountItem[item.key])}`}}</div>
        <div v-else-if="item.type=='time'" class="nowrap">{{ accountItem[item.key]?moment(accountItem[item.key]).format('YYYY-MM-DD'):'--'}}</div>
        <div v-else-if="item.type=='img'" class="nowrap"><img :src="accountItem[item.key]" width="60" height="60"/> </div>
        <div v-else-if="item.type=='file'" class="nowrap">
          <div v-if="accountItem[item.key]?.length>0">
            <div v-for="(f,i) in accountItem[item.key]" :key="i" class="file nowrap" @click="handleFileViewing(f)"> {{f?.name}}</div>
          </div>
          <div v-else style="color:#909399">暂无附件</div>
        </div>
        <div v-else>{{accountItem[item.key]?accountItem[item.key]:'--'}}</div>
      </div>
    </div>
    <!-- 表单按钮 -->
    <div class="absoluteGrop">
      <el-button v-if="accountItem.approvalStatus==1" type="primary" plain @click="approveRow(1)">审批通过</el-button>
      <el-button v-if="accountItem.approvalStatus==1" type="danger" plain @click="approveRow(0)">审批驳回</el-button>
      <el-button plain @click="$router.go(-1)">返 回</el-button>
    </div>
    <!-- 预览组件 -->
    <PreviewFile ref="previewFile"></PreviewFile>
  </div>
</template>
<script>
import moment from 'moment';
import PreviewFile from "../../../components/file-preview.vue"
export default {
  name: "detail_accountManage",
  components: { PreviewFile },
  data() {
    return {
      moment: moment,
      accountItem: {},
      // 信息字段
      keyItems: [
        // { title: "一级用户名称", key: "registerMail" },
        { title: "账号用户名", key: "registerMail" },
        { title: "企业电话", key: "enterpriePhone" },
        { title: "企业邮箱", key: "enterprieMail" },
        { title: "企业LOGO", key: "logo", type: "file" },
        { title: "目前所涉及的行业", key: "category" },
        { title: "统一社会信用代码", key: "code" },
        { title: '企业地址', key: 'address' },
        { title: "注册时间", key: "createTime", type: "time" },
        { title: "企业联系人", key: "enterprieContacts" },
        { title: "联系人电话", key: "contactsPhone" },
        { title: "联系人邮箱", key: "contactsMail" },
        { title: "企业法人", key: "enterpriseLegalPerson" },
        { title: "法人联系方式", key: "enterpriseLegalPersonPhone" },
        { title: "营业执照", key: "businessLicense", type: "file" }
      ],
    };
  },
  created() {
    this.getInfo();
  },
  computed: {
    InnerWH: function () {
      return this.$store.getters.getInnerWH;
    },
  },
  methods: {
    // 获取信息
    getInfo() {
      this.$axios
        .post(`${process.env.BASE_URL}api/user/userInfo`, { id: this.$route.query.id }).then((res) => {
          if (res.data.code == 200) {
            this.accountItem = res.data.data;
            let fileKes = ['businessLicense','logo'];
            fileKes.forEach((key, i) => {
              if (res.data.data[key] && res.data.data[key] != '') {
                this.$set(this.accountItem, key, JSON.parse(res.data.data[key]))
              }
            });
          } else {
            console.log(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 审批
    approveRow(result) {
      this.$msgbox({
        title: result == 1 ? '通过' : '驳回',
        message: `是否确定${result == 1 ? '通过' : '驳回'}该用户？`,
        showCancelButton: true,
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            let that = this;
            this.$axios
              .post(`${process.env.BASE_URL}api/user/approve`, { id: this.accountItem.id,approvalStatus:result == 1 ? 2 : 3 }).then(res => {
                if (res.data.code == 200) {
                  that.$message({
                    message: '审批成功',
                    type: "success"
                  });
                  this.$router.push('/accountPages/accountManage')
                } else {
                  that.$message({
                    message: res.data.msg,
                    type: "error"
                  });
                }
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              }).catch(() => {
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              });
          } else {
            //确认弹窗还原&关闭
            instance.confirmButtonText = '确定';
            instance.confirmButtonLoading = false;
            done();
          }
        }
      }).then(action => {
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消操作",
          offset: 100
        });
      })
    },
    // 预览
    handleFileViewing(file) {
      this.$refs.previewFile.openDrawer([file]);
    }
  },
};
</script>
<style lang="less" scoped>
.form_detail {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f9fafb;
  margin-bottom: 45px;
  color: #111928;
  > div {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #e5e7eb;
    > div {
      padding: 8px 15px;
    }
    > div:first-child {
      color: #6b7280;
      width: 15vh;
      position: relative;
      flex-shrink: 0;

      &::after {
        content: "";
        position: absolute;
        right: 0px;
        width: 2px;
        height: 60%;
        top: 20%;
        font-size: 20px;
        background: #e5e7eb;
      }
    }
    .file {
      text-decoration-line: underline;
      cursor: pointer;
    }
  }
}
</style> 